<template>
  <div class="contacts-list">
    <section class="data-table" :class="{loading: isLoading}">
      <section class="data-header">
        <div class="data-col col1">{{ $t('component.contacts.list.labelPhone') }}</div>
        <div class="data-col col2">{{ $t('component.contacts.list.labelName') }}</div>
        <div class="data-col col3">{{ $t('component.contacts.list.labelAutotopup') }}</div>
        <div class="data-col col4">{{ $t('component.contacts.list.labelPaymentMethod') }}</div>
        <div class="data-col col5"></div>
      </section>
      <section class="data-content">
        <div class="data-row" v-for="(item, index) in contacts" :key="index">
          <div class="data-col col1">
            <div class="label-mobile">{{ $t('component.contacts.list.labelPhone') }}:</div>
            {{ item.msisdn | phone }}
          </div>
          <div class="data-col col2">
            <div class="label-mobile">{{ $t('component.contacts.list.labelName') }}:</div>
            {{ item.description }}
          </div>
          <div class="data-col col3">
            <div class="label-mobile">{{ $t('component.contacts.list.labelAutotopup') }}:</div>
            <div v-if="item.recurringTopup">
              <div v-if="isAutotopupConditionPeriodSet(item.recurringTopup.recurringTopupType)">
                <div class="autotopup-link"
                     v-html="$t('component.contacts.list.topupPeriodConditions', {amount: item.recurringTopup.amount, day: item.recurringTopup.day})"></div>
                <div class="autotopup-text">
                  {{ $t('component.contacts.list.topupPeriodNextDate') }}
                  <strong>{{ item.recurringTopup.nextTopupDate | dateShort }}</strong>
                </div>
              </div>
              <div v-if="isAutotopupConditionDaySet(item.recurringTopup.recurringTopupType)">
                <div class="autotopup-link"
                     v-html="$t('component.contacts.list.topupDayConditions', {amount: item.recurringTopup.amount, day: item.recurringTopup.day})"></div>
              </div>
              <div></div>
            </div>
            <el-button type="primary"
                       icon="el-icon-plus"
                       size="mini"
                       plain
                       @click="goToAutotopup(item)"
                       v-if="!item.recurringTopup"
                       :title="$t('component.contacts.list.a11y.topupButtonAdd')">
              {{ $t('component.contacts.list.topupButtonAdd') }}
            </el-button>
          </div>
          <div class="data-col col4">
            <div class="label-mobile">{{ $t('component.contacts.list.labelPaymentMethod') }}:</div>
            <div v-if="item.recurringTopup">
              <div v-if="item.recurringTopup.paymentMethodType === PAYMENT_METHOD_TYPE.creditCard">
                {{ $t('component.contacts.list.paymentMethodCard') }}
              </div>
              <div v-if="item.recurringTopup.paymentMethodType === PAYMENT_METHOD_TYPE.blikRecurring">
                {{ $t('component.contacts.list.paymentMethodBlik') }}
              </div>
            </div>
          </div>
          <div class="data-col col5">
            <el-tooltip :content="$t('component.contacts.list.tooltipButtonTopup')" placement="top">
              <el-button type="primary" icon="el-icon-refresh-right" plain size="mini" @click="topupContact(item)"
                         :title="$t('component.contacts.list.a11y.topupButton')"></el-button>
            </el-tooltip>
            <el-tooltip :content="$t('component.contacts.list.tooltipButtonEdit')" placement="top">
              <el-button type="primary" icon="el-icon-edit" plain size="mini" @click="editContactItem(item)"
                         :title="$t('component.contacts.list.a11y.topupButtonEdit')"></el-button>
            </el-tooltip>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import ContactsListMixin from '@/common/mixins/Contacts/List.mixin'

export default {
  name: 'ContactsList',
  mixins: [ContactsListMixin]
}
</script>

<style src="../../assets/scss/contacts.scss" lang="scss"></style>
<style src="../../assets/scss/table.scss" lang="scss"></style>
<style lang="scss">
@import '../../assets/scss/variables';
.contacts-list {
  @media (min-width: $res-m) {
    .col1 { width: 100px }
    .col2 { width: 130px }
    .col3 { width: 180px }
    .col4 { width: 100px }
    .col5 { width: 60px }
  }
  @media (min-width: $res-l) {
    .col1 { width: 110px }
    .col2 { width: 180px }
    .col3 { width: 240px }
    .col4 { width: 160px }
    .col5 { width: 60px }
  }
  @media (min-width: $res-xl) {
    .col1 { width: 110px }
    .col2 { width: 240px }
    .col3 { width: 280px }
    .col4 { width: 180px }
    .col5 { width: 60px }
  }
}
</style>
